import React from "react";

import { useAppTheme } from "@bridgesplit/react";
import { DialogProvider, LoopscaleTrackingProvider, createThemeOptions } from "@bridgesplit/ui";
import { createTheme } from "@mui/material/styles";
import ThemeProvider from "@mui/system/ThemeProvider";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
    OraclePriceProvider,
    PrivyWalletProvider,
    PrivyWalletConnectionProvider,
    LoopscaleWalletProvider,
    UserTokensProvider,
    FarmingInfosProvider,
    TokenListProvider,
    TokenRestrictionsProvider
} from "@bridgesplit/abf-react";

import { useTrack } from "../../hooks";
import AppAlerts from "./AppAlerts";

// When auth0 runs in a separate domains from browser, session auth doesn't work
// https://auth0.com/docs/troubleshoot/authentication-issues/renew-tokens-when-using-safari
export default function Providers({ children }: { children: React.ReactNode }) {
    const { mode } = useAppTheme();
    const theme = createTheme(createThemeOptions(mode));
    const track = useTrack();

    return (
        <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <PrivyWalletProvider>
                    <LoopscaleWalletProvider>
                        <UserTokensProvider>
                            <TokenListProvider>
                                <TokenRestrictionsProvider>
                                    <PrivyWalletConnectionProvider>
                                        <DialogProvider>
                                            <AppAlerts>
                                                <LoopscaleTrackingProvider trackEvent={track.rawTrack}>
                                                    <OraclePriceProvider>
                                                        <FarmingInfosProvider>{children} </FarmingInfosProvider>
                                                    </OraclePriceProvider>
                                                </LoopscaleTrackingProvider>
                                            </AppAlerts>
                                        </DialogProvider>
                                    </PrivyWalletConnectionProvider>
                                </TokenRestrictionsProvider>
                            </TokenListProvider>
                        </UserTokensProvider>
                    </LoopscaleWalletProvider>
                </PrivyWalletProvider>
            </LocalizationProvider>
        </ThemeProvider>
    );
}
